import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { ContactListEditComponent } from '../contact-list-edit/contact-list-edit.component';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { IContactList } from '../icontact-list';
import { ContactList } from '../contact-list.model';
import { CustomFieldAssignComponent } from '../../basics/custom-field-assign/custom-field-assign.component';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../nav-menu/user-company.service';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.css']
})


export class ContactListComponent implements OnInit, OnDestroy {
  @ViewChild('editModal', { static: false }) editModal: ContactListEditComponent;
  @ViewChild('msgDialog', { static: false }) msgDialog: MessageDialogComponent;
  @ViewChild('assignCustomField', { static: false }) assignModal: CustomFieldAssignComponent;

  private contactLists: IContactList[] = [];
  private dataTable: any;
  private dtTable: any;
  private navbarHeadline: any;
  private selectedCompany: number;
  private subs = new SubSink();

  constructor(private repository: HttpRepositoryService,
    private router: Router, private titleService: Title,
    private antiForgery: AntiForgeryTokenService,
    private companyService: UserCompanyService) { }

  ngOnInit() {
    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });
    
    this.dataTable = $('#contactListTable');
    this.navbarHeadline = $('#navbarHeadline');
    this.createDataTable();

    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpResp => {
      this.selectedCompany = cmpResp;
      this.loadData();

    });

  }

  private createDataTable() {
    this.contactLists.forEach(function (item) {
      if (item.ownerName.includes(item.ownerEmail)) {
        item.ownerName = item.ownerName;
      } else {
        item.ownerName = item.ownerName ? item.ownerName : '' + " - " + item.ownerEmail ? item.ownerEmail : '';
      }
    });

    var that = this;

    var dtOptions = {
      data: this.contactLists,
      columns: [
        {
          name: 'id',
          visible: false
        },
        {
          name: 'name'
        },
        {
          name: 'ownerName'
        },
        {
          name: 'insAt',
          width: '100px'
        },
        {
          name: 'haveCustomFields',
          class: 'text-center',
          filterable: false,
          width: '100px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        }
      ],
      orderBy: [[0, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="fas fa-list pr-3"></i> View',
          class: 'viewrow',
          dataAttributes: ['id'],
          action: function (id) {
            that.viewContacts(id);
          }
        },
        {
          text: '<i class="fas fa-edit pr-3"></i> Edit',
          class: 'editrow',
          dataAttributes: ['id'],
          action: function (id) {
            that.edit(id);
          }
        },
        {
          text: '<i class="fas fa-trash pr-3"></i> Remove',
          class: 'deleterow',
          dataAttributes: ['id'],
          action: function (id) {
            that.delete(id);
          }
        }]
      },
      buttons: [{
        text: '<i class="fas fa-plus"></i>',
        class: '',
        action: function () {
          that.create()
        }
      },
      {
        text: '<i class="fas fa-trash-alt"></i>',
        class: '',
        action: function () {
          that.deleteList()
        }
      },
      {
        text: '<i class="far fa-check-square"></i>',
        class: '',
        action: function () {
          that.assignCustomFields()
        }
      }]
    }

    if (this.dtTable)
      this.dtTable.Destroy();

    this.dtTable = this.dataTable.LinkTable(dtOptions);
  }

  private loadData() {
    this.navbarHeadline.html(" Contact Lists");

    this.subs.sink = this.repository.get<IContactList[]>('api/ContactList/DetailedList?id=' + this.selectedCompany).pipe(map(x => x.data))
      .subscribe(fields => {
        this.contactLists = fields;
        this.createDataTable();
      });
  }

  create() {
    if (this.selectedCompany == 0) {
      this.msgDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, "Create contact list.");
    } else {
      this.editModal.show(new ContactList(), true, this.selectedCompany);
    }
  }

  edit(id) {
    if (this.selectedCompany == 0) {
      this.msgDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, "Update contact list.");
    } else {
      let contactList = this.contactLists.find(x => x.id === id);

      if (contactList) {
        this.subs.sink = this.repository.get<ContactList>('api/ContactList/Details/' + contactList.id + '?companyId=' + this.selectedCompany).pipe(map(x => x.data))
          .subscribe(data => {
            this.editModal.show(data, false, this.selectedCompany);
          });
      }
    }
  }

  delete(id) {
    if (this.selectedCompany == 0) {
      this.msgDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, "Delete contact list.");
    } else {
      var contactList = this.contactLists.find(x => x.id === id);

      if (contactList) {
        this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
          if (afResp.hasErrors) {
            Toast.Show(afResp.error, 'Remove contact list', 'error');
          } else {
            this.msgDialog.show("Are you sure you want to delete " + contactList.name + "?", MessageType.YESNO, 'Delete conformation!', () => {
              this.subs.sink = this.repository.del('api/ContactList/Remove/' + id + '?companyId=' + this.selectedCompany, afResp.data).subscribe(resp => {
                if (resp.hasErrors) {
                  Toast.Show(resp.error, 'Remove contact list', 'error');
                } else {
                  Toast.Show('Contact list successfully removed.', 'Remove contact list', 'success');
                  this.loadData();
                }
              });
            });
          }
        });
      }
    }

  }

  private viewContacts(id) {
    var contactList = this.contactLists.find(x => x.id === id);

    if (contactList) {
      this.router.navigate(['/contactlist', contactList.id]);
    }
  }

  private onSaved(data: ContactList) {
    var contactList = this.contactLists.find(x => x.id === data.id);

    if (contactList) {
      contactList.name = data.name;
      contactList.ownerName = data.ownerName;
      contactList.ownerName = data.ownerName + " - " + data.ownerEmail;
      contactList.haveCustomFields = data.customFields.length > 0;
      contactList.insAt = data.insAt;
    } else {
      this.contactLists.push({ id: data.id, name: data.name, ownerName: data.ownerName, insAt: data.insAt, ownerEmail: data.ownerEmail, haveCustomFields: data.customFields.length > 0 });
    }

    this.createDataTable();
  }

  deleteList() {
    if (this.selectedCompany == 0) {
      this.msgDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, "Delete contact list.");
    } else {
      let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.id);

      if (checked.length == 0) {
        this.msgDialog.show("You must select contact list!", MessageType.OK, "Delete conformation");
      } else {
        this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
          if (afResp.hasErrors) {
            Toast.Show(afResp.error, 'Remove contact list(s)', 'error');
          } else {
            this.msgDialog.show("Are you sure you want do delete " + checked.length + " item(s)?", MessageType.YESNO, "Delete conformation", () => {
              this.subs.sink = this.repository.post<number[]>('api/ContactList/ListRemove?companyId=' + this.selectedCompany, checked, afResp.data).subscribe(resp => {
                if (resp.hasErrors) {
                  Toast.Show(resp.error, 'Remove contact list(s)', 'error');
                } else {
                  Toast.Show('Contact list(s) successfully removed.', 'Remove contact list(s)', 'success');
                  this.loadData();
                }
              });
            });
          }
        });
      }
    }
  }

  assignCustomFields() {
    if (this.selectedCompany == 0) {
      this.msgDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, "Assign custom fields.");
    } else {
      let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.id);

      if (checked.length === 0) {
        this.msgDialog.show("You must select item.", MessageType.OK, "Assign custom fields");
      } else {
        this.assignModal.show(checked);
      }
    }
  }

  onAssigned(data) {
    this.loadData();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }
  }
}
